import { IError, IGizmoCallbacks } from '../../types';
import Gizmo from '../gizmo';

interface IParams {
  context: {
    gizmo: Gizmo;
    callbacks: IGizmoCallbacks;
  };
}

/**
 * Run a server validation configured in the gizmo
 *
 * @returns {IError[]} validation errors
 */
function serverValidation({ context }: IParams): Promise<IError[]> {
  return new Promise<IError[]>(async resolve => {
    const { gizmo, callbacks } = context;
    const dao = gizmo.getDao();
    const rootGizmoData = callbacks.getInfoCB({
      type: 'rootGizmoData',
    });

    if (dao) {
      const validationErrors = await dao.serverValidation({
        config: gizmo.getConfig(),
        rootGizmoData,
      });

      return resolve(validationErrors);
    }

    resolve([]);
  });
}

export default serverValidation;
